module.exports = __webpack_public_path__ + "static/media/filter.b80b305a.svg";